// extracted by mini-css-extract-plugin
export var container = "SeeAlso-module--container--h9CIB";
export var link = "SeeAlso-module--link--dhWCY";